import { DATA_SOURCES } from '@/config/constants';
import EntityHeroCard from '../shared/entity/EntityHeroCard';
import EntityPage from '../shared/entity/EntityPage';
import EntityRelatedTable from '../shared/entity/EntityRelatedTable';
import EntityTabs, { EntityTab } from '../shared/entity/EntityTabs';
import EntityTopPosts from '../shared/entity/EntityTopPosts';
import EntityTopTerms from '../shared/entity/EntityTopTerms';
import {
    GOOGLE_METADATA_BY_KEY,
    INSTAGRAM_METADATA_BY_KEY,
} from 'utils/metrics';
import {
    getInstagramHealthStats,
    getTikTokAndSearchHealthStats,
} from 'state/utils';
import { InstagramChartCard } from '../shared/entity/chartCards';
import { InstagramRelatedCategoriesSectionTable } from 'components/DataVis/InstagramRelatedCategoriesTable';
import ToggleWatch from 'components/Button/ToggleWatch';
import TopPostsSection from 'components/Posts/Instagram/TopPostsSection/BrandOnlyTopPostsSection';
import { TopInstagramHashtagsSection } from 'components/TopKeywordsSection';
import useInstagramEntity from '../shared/entity/useInstagramEntity';
import { useTrackBrandView } from 'utils/hooks/useTrackEntityView';

const METRICS = [
    INSTAGRAM_METADATA_BY_KEY.likes,
    GOOGLE_METADATA_BY_KEY.price_segmentation,
];

function InstagramBrandPage({ brandId, controller }) {
    const page = useInstagramEntity({
        entityType: 'brands',
        entityId: brandId,
        controller,
    });
    const { name, country, entity, row } = page;

    const healthStats = {
        ...getInstagramHealthStats(row),
        ...getTikTokAndSearchHealthStats({
            healthStatKeys: ['price point'],
            price: entity?.price,
        }),
    };

    useTrackBrandView(DATA_SOURCES.INSTAGRAM, {
        brandId,
        brandName: name,
        countryName: country?.name || null,
    });

    return (
        <EntityPage
            page={page}
            title={{ name, isLoading: page.entityQuery.isLoading }}
            actions={
                <ToggleWatch id={brandId} data={{ name, type: 'brand' }} />
            }
            space="1.5rem"
            sections={
                <>
                    <EntityTopTerms
                        as={TopInstagramHashtagsSection}
                        highlighted
                    />
                    <EntityTopPosts as={TopPostsSection} />
                </>
            }
            tabs={
                <EntityTabs>
                    <EntityTab name="Related Categories">
                        <EntityRelatedTable
                            as={InstagramRelatedCategoriesSectionTable}
                            subject="categories"
                            icon="affinity"
                            title="Related Categories"
                            exportType="related-category"
                            exportEntity={name || 'brand'}
                        />
                    </EntityTab>
                </EntityTabs>
            }
        >
            <div className="flex flex-col gap-3">
                <EntityHeroCard healthStats={healthStats} />
                <InstagramChartCard
                    metricList={METRICS}
                    healthStats={healthStats}
                />
            </div>
        </EntityPage>
    );
}

InstagramBrandPage.displayName = 'InstagramBrand';

export default InstagramBrandPage;
